import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    IconButton,
    InputAdornment,
    Typography,
    Box,
    CircularProgress
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { useForm } from 'react-hook-form';
import { GToaster } from './g_toaster';
import axios from 'axios';
import { Apiurl } from '../api_urls';
const toster = new GToaster()
const ChangePasswordModal = ({ open, onClose, usertype, uid }) => {
    const {
        register,
        handleSubmit,
        watch,
        formState: { errors, isSubmitting },
        reset,
    } = useForm();

    const [showOld, setShowOld] = useState(false);
    const [showNew, setShowNew] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);

    const toggleVisibility = (field) => {
        if (field === 'old') setShowOld((prev) => !prev);
        if (field === 'new') setShowNew((prev) => !prev);
        if (field === 'confirm') setShowConfirm((prev) => !prev);
    };

    const newPassword = watch('newPassword');

    const handleFormSubmit = async (data) => {
        let obj = {
            role: usertype,
            user_id: uid,
            old_password: data?.oldPassword,
            new_password: newPassword
        }
        const token = localStorage.getItem("access_token");
        const role = localStorage.getItem("role");
                
        await axios.post(Apiurl.CHNAGE_PASSWORD_URL,obj, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        Role: role
                    }
                }).then((response) => {
            if (response.status === 200) {
                if (response.data?.status === 200) {
                    toster.success({ title: "Password Successfully Updated" });
                } else {
                    toster.error({ title: response?.data?.message });
                }
            } else {
                toster.error({ title: response?.data?.message });
            }
        }).catch((err) => {
            toster.error({ title: err?.data?.message });
        })

        reset();
        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>
                <Typography variant="h6">Change Password</Typography>
            </DialogTitle>

            <DialogContent>
                <Box
                    component="form"
                    onSubmit={handleSubmit(handleFormSubmit)}
                    id="change-password-form"
                >
                    <TextField
                        label="Old Password"
                        size='small'
                        type={showOld ? 'text' : 'password'}
                        fullWidth
                        margin="normal"
                        {...register('oldPassword', { required: 'Old password is required' })}
                        error={!!errors.oldPassword}
                        helperText={errors.oldPassword?.message}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton onClick={() => toggleVisibility('old')} edge="end">
                                        {showOld ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />

                    <TextField
                        label="New Password"
                        size='small'
                        type={showNew ? 'text' : 'password'}
                        fullWidth
                        margin="normal"
                        {...register('newPassword', {
                            required: 'New password is required',
                            minLength: {
                                value: 6,
                                message: 'Password must be at least 6 characters',
                            },
                        })}
                        error={!!errors.newPassword}
                        helperText={errors.newPassword?.message}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton onClick={() => toggleVisibility('new')} edge="end">
                                        {showNew ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />

                    <TextField
                        label="Confirm Password"
                        size='small'
                        type={showConfirm ? 'text' : 'password'}
                        fullWidth
                        margin="normal"
                        {...register('confirmPassword', {
                            required: 'Please confirm your password',
                            validate: value => value === newPassword || 'Passwords do not match',
                        })}
                        error={!!errors.confirmPassword}
                        helperText={errors.confirmPassword?.message}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton onClick={() => toggleVisibility('confirm')} edge="end">
                                        {showConfirm ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />
                </Box>
            </DialogContent>

            <DialogActions sx={{ px: 3, pb: 2, display: "flex", justifyContent: "space-between" }}>
                <Button onClick={onClose} color="secondary" variant="contained">
                    Cancel
                </Button>
                <Button
                    type="submit"
                    form="change-password-form"
                    variant="contained"
                    color="primary"
                    disabled={isSubmitting}
                    startIcon={
                        isSubmitting ? (
                            <CircularProgress size={20} color="inherit" />
                        ) : null
                    }
                >
                    {isSubmitting ? 'Changing...' : 'Change Password'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ChangePasswordModal;
